<template>
  <div class="row">
    <div class="col-md-12 header-row">
      <h3 class="heading semi-bold">Select a Fabric</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="input-group transparent">
            <span class="input-group-addon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              @keyup.enter="searchFabric($event.target.value)"
              class="form-control search-fabric"
              placeholder="Search Fabric"
            />
          </div>
        </div>
        <div class="col-md-9 text-right">
          <router-link
            :to="{ path: '/fabric/status/log/daily' }"
            class="btn btn-primary"
          >
            View Fabric Status Changes by Date
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row flex">
        <div class="col-md-3" v-for="fabric in fabrics" :key="fabric.id">
          <fabric-list-card :fabric="fabric" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import FabricListCard from "./components/FabricListCardStatusLog";
export default {
  components: {
    FabricListCard,
  },
  data() {
    return {
      allData: [],
      fabrics: [],
      searchResults: [],
    };
  },
  mounted() {
    this.getFabrics();
  },
  methods: {
    async getFabrics() {
      try {
        let results = await axios.get("/v2/fabrics", {
          params: {
            columns: "id,name,status",
            sort: "id:asc",
            relationships: "images",
            per_page: 0,
          },
        });
        let collection = results.data.data.collection;

        let fabrics = collection.map((fabric) => {
          let images = fabric.images;
          if (images.length > 0) {
            // Use backend as main image
            let image = images.find((img) => {
              return img.type === "backend";
            });
            // Use the first image if the previous type is not found.
            if (!image) {
              image = images[0];
            }
            fabric["image_url"] = image.image_url;
          } else {
            fabric["image_url"] = "/assets/img/fabric-placeholder.png";
          }
          return fabric;
        });
        this.fabrics = fabrics;
        this.allData = fabrics;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to show fabrics, server error occurred.");
        }
      }
    },

    searchFabric(search) {
      if (search !== "") {
        this.fabrics = this.allData.filter((obj) => {
          return (
            obj.name.toLowerCase().includes(search.toLowerCase()) ||
            $Fabric.getCode(obj.id) === parseInt(search)
          );
        });
      } else {
        this.fabrics = this.allData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-row {
  margin-bottom: 20px;
}

.header-row .search-fabric {
  height: 38px;
}
</style>
